export const localStorageConst = {
  UserName: "username",
  Password: "password",
  PhoneNumber: "phoneNumber",
  IsSignClicked: "isSignClicked",
  IsDeleteSignClicked: "isDeleteSignClicked",
};

export const ErrorDefinition = {
  SingInErrorCode: "UserNotConfirmedException",
  ChangeEmailError: "An account with the email already exists.",
  ConfirmAttributeCodeError:
    "Invalid verification code provided, please try again.",
};

export const BooleanDefinition = {
  True: "true",
  False: "false",
};

export const SuccessMessage = {
  Success: "success",
  UserDelete: "Hesabınız silindi.",
};

export const ConsentConfig = [
  {
    id: "kvkk",
    uri: `${process.env.REACT_APP_BASE_URL}/api/Consent/Get/?bundleId=5`,
    lang: "TR",
  },
  {
    id: "kvkk",
    uri: `${process.env.REACT_APP_BASE_URL}/api/Consent/Get/?bundleId=37`,
    lang: "EN",
  },
  {
    id: "kvkk",
    uri: `${process.env.REACT_APP_BASE_URL}/api/Consent/Get/?bundleId=38`,
    lang: "DE",
  },
  {
    id: "loyalty",
    uri: `${process.env.REACT_APP_BASE_URL}/api/Consent/Get/?bundleId=28`,
    lang: "TR",
  },
  {
    id: "loyalty",
    uri: `${process.env.REACT_APP_BASE_URL}/api/Consent/Get/?bundleId=34`,
    lang: "EN",
  },
  {
    id: "loyalty",
    uri: `${process.env.REACT_APP_BASE_URL}/api/Consent/Get/?bundleId=35`,
    lang: "DE",
  },
];

export const messageKeyMap = {
  accountDeleted: "userDelete.deletedAccountResponse",
  phoneNumberChanged: "changeProfile.successPopupTitle",
  emailChanged: "changeProfile.successPopupTitle",
  passwordChanged: "changePassword.successMessage",
};
